import { cn } from '../lib/ui';

/** A vendor's logo (an https image address, D68 item 10), or its initial. */
export default function VendorLogo({ vendor, size = 'size-14' }) {
  if (!vendor.logoUrl) {
    return (
      <span
        aria-hidden="true"
        className={cn(
          size,
          'inline-flex shrink-0 items-center justify-center rounded-dcon-md bg-dcon-brand-soft font-display text-title-s text-dcon-brand'
        )}
      >
        {vendor.businessName.slice(0, 1).toUpperCase()}
      </span>
    );
  }
  return (
    <img
      src={vendor.logoUrl}
      alt=""
      className={cn(
        size,
        'shrink-0 rounded-dcon-md border border-z-line bg-z-surface object-contain'
      )}
      referrerPolicy="no-referrer"
    />
  );
}
